<template>
<div class="wrapper-landing">
  <mq-layout :mq="['m480', 'm576', 'm768', 'm991']">
    <LandingHero2
      title="Crea tu lista de deseos con HelloWish Premium"
      subtitle="Te ofrecemos gratis la mejor versión de nuestra wishlist multi-tienda."
      buttonText="Obtén Premium Gratis"
      origin="free-premium"
      logoStyle="white"
      coverIsVertical="true"
      listType="wishlist"
      promoCode="guest_loop"
    >
      <template v-slot:cover>
        <source
          media="(max-width: 991px)"
          class=""
          srcset="../../assets/images/hellobb-premium-banner-landscape.png"
          alt=""
          loading="lazy"
        />
        <img
          class="ln-hero__inset"
          src="../../assets/images/hellobb-premium-banner-landscape.png"
          alt=""
          loading="lazy"
        />
      </template>
    </LandingHero2>
  </mq-layout>
  <mq-layout :mq="['m1200']">
    <LandingHero
      title="Crea tu lista de deseos con HelloWish Premium"
      subtitle="Te ofrecemos gratis la mejor versión de nuestra wishlist multi-tienda."
      buttonText="Obtén Premium Gratis"
      origin="free-premium"
      logoStyle="white"
      coverIsVertical="true"
      listType="wishlist"
      promoCode="guest_loop"
    >
      <template v-slot:cover>
        <source
          media="(max-width: 991px)"
          class=""
          srcset="../../assets/images/hellobb-premium-banner-large.png"
          alt=""
          loading="lazy"
        />
        <img
          class="ln-hero__inset"
          src="../../assets/images/hellobb-premium-banner-large.png"
          alt=""
          loading="lazy"
        />
      </template>
    </LandingHero>
    </mq-layout>  
    <main class="bg-cercles">
      <LandingAppRatings />
      <div class="landing-premium">
        <div class="landing-premium-title">Te regalamos Premium</div>
        <div class="landing-premium-description">Disfruta sin límites de todas las funcionalidades de HelloWish para crear tu lista de deseos. Sin publicidad para ti ni para la gente con la que compartas tu lista.</div>
      </div>
      <section class="bb-container">
        <LandingFeaturesSimple title="Necesitas una lista de HelloWish si:"
        :use-carousel="false"
        >
        <LandingFeaturesSimpleItem>
            <template slot="ico">
              <img src="../../assets/img/ico/ico-color-clipboard.svg" alt="" />
            </template>
            <template slot="title">
              Te gusta organizarte y no te quieres olvidar de nada
            </template>
          </LandingFeaturesSimpleItem>
          <LandingFeaturesSimpleItem>
            <template slot="ico">
              <img src="../../assets/img/ico/ico-color-mobile-cart.svg" alt="" />
            </template>
            <template slot="title"> Quieres pedir cosas de varias tiendas </template>
          </LandingFeaturesSimpleItem>
          <LandingFeaturesSimpleItem>
            <template slot="ico">
              <img src="../../assets/img/ico/ico-color-hand-heart.svg" alt="" />
            </template>
            <template slot="title">
              Buscas una forma simpática y sencilla de compartir tus deseos
            </template>
          </LandingFeaturesSimpleItem>
          <LandingFeaturesSimpleItem>
            <template slot="ico">
              <img src="../../assets/img/ico/ico-color-q.svg" alt="" />
            </template>
            <template slot="title">
                Tu círculo necesita un poco de ayuda para acertar tus regalos
            </template>
          </LandingFeaturesSimpleItem>
        </LandingFeaturesSimple>
      </section>
    </main>

    <LandingFeaturesCover title="Una lista cargada de cosas buenas">
      <LandingFeaturesCoverItem>
        <template slot="cover">
          <img src="../../assets/img/landings/cover-retailers-box.png" alt="" />
        </template>
        <template slot="titulo">
          Pide cualquier modelo, de cualquier marca, de cualquier tienda
        </template>

        <template slot="descripcion">
          <p>
            Copia cualquier enlace y guárdalo en tu lista. Libertad total para escoger
            justo lo que quieres.
          </p>
        </template>
      </LandingFeaturesCoverItem>
      <LandingFeaturesCoverItem>
        <template slot="cover">
          <img src="../../assets/img/covers/cover-regalos-efectivo.svg" alt="" />
        </template>
        <template slot="titulo"> Recibe dinero sin comisiones </template>

        <template slot="descripcion">
          <p>
            Tus allegados podrán regalarte cosas o mandarte dinero para que las compres tú. Como propietario de la lista, no pagas nada por recibir dinero.
          </p>
        </template>
      </LandingFeaturesCoverItem>
      <!-- <LandingFeaturesCoverItem>
        <template slot="cover">
          <img src="../../assets//img/covers/mockup_aportaciones_ES.png" alt="" />
        </template>
        <template slot="titulo"> Ofrece la posibilidad de compartir las compras más caras </template>

        <template slot="descripcion">
          <p>
            Además, tu familia y amigos podrán colaborar con aportaciones parciales
                para comprar las cosas más caras entre todos.
          </p>
        </template>
      </LandingFeaturesCoverItem> -->
      <FeaturesCoverItemListUpdate lang="es-ES" />
    </LandingFeaturesCover>
    

    <main class="bg-cercles">
      <section class="bb-container">
        <LandingReviewsWedding />
        <LandingHablan />
      </section>
    </main>

    <LandingComoCols title="¿Cómo funciona?" subtitle="Tu lista de deseos sin límites">
      <LandingComoColsItem>
        <template slot="icono">
          <img src="../../assets/img/ico/ico-max-click.svg" alt="" />
        </template>
        <template slot="titulo">Elige qué quieres</template>
        <template slot="descripcion">
          <p>
            Escoge el objeto que quieras de cualquier tienda online, copia el enlace en
            HelloWish y guárdalo.
          </p>
          <p>
            También puedes tener una Hucha para reunir dinero para lo que
            quieras.
          </p>
        </template>
      </LandingComoColsItem>
      <LandingComoColsItem>
        <template slot="icono">
          <img src="../../assets/img/ico/ico-max-share.svg" alt="" />
        </template>
        <template slot="titulo">Comparte tus deseos</template>
        <template slot="descripcion">
          <p>Cuando quieras, comparte tu lista con tus familiares y amigos.</p>
          <p>
            Enviales un enlace para que accedan desde cualquier sitio y sin registrarse a
            una bonita lista personalizada por ti.
          </p>
        </template>
      </LandingComoColsItem>
      <LandingComoColsItem>
        <template slot="icono">
          <img src="../../assets/img/ico/ico-max-gift.svg" alt="" />
        </template>
        <template slot="titulo">Consigue los regalos</template>
        <template slot="descripcion">
          <p>
            Tus allegados podrán escoger el regalo de tu lista que más les guste y
            comprarlo. Te lo podrán mandar a ti o a ellos para dároslo en una visita.
          </p>
          <p>
            Para que nadie más lo compre, podrán marcar en la lista que ya está regalado.
          </p>
        </template>
      </LandingComoColsItem>
    </LandingComoCols>

    <LandingFooter />
  </div>
</template>

<script>
import LandingFeaturesSlider from "./components/LandingFeaturesSlider.vue";

import LandingFeaturesSimple from "./components/LandingFeaturesSimple.vue";
import LandingFeaturesSimpleItem from "./components/LandingFeaturesSimpleItem.vue";

import LandingHero from "./components/LandingHero.vue";
import LandingHero2 from "./components/LandingHero2.vue";
import LandingAppRatings from "./components/LandingAppRatings.vue";
import LandingFeaturesCover from "./components/LandingFeaturesCover";
import LandingFeaturesCoverItem from "./components/LandingFeaturesCoverItem";
import LandingReviewsWedding from "./components/LandingReviewsWedding.vue";
import LandingHablan from "./components/LandingHablan.vue";
import LandingFooter from "./components/LandingFooter.vue";

import LandingComoCards from "./components/LandingComoCards.vue";
import LandingComoCardsItem from "./components/LandingComoCardsItem.vue";
import LandingComoColsItem from "./components/LandingComoColsItem.vue";
import LandingComoCols from "./components/LandingComoCols.vue";

import FeaturesCoverItemListUpdate from "./components/FeaturesCoverItemListUpdate.vue";

export default {
  name: "LandingFreePremium",
  metaInfo() {
    return {
      title: "Consigue HelloWish Premium Gratis",
      meta: [
        { name: "description", content: "HelloWish es la lista donde caben absolutamente todos tus deseos. Consigue la versión Premium Gratis.." },
        { name: "robots", content: "noindex" },
      ],
    };
  },
  components: {
    LandingComoCols,
    LandingComoColsItem,
    LandingAppRatings,
    LandingHablan,
    LandingReviewsWedding,
    LandingFooter,
    LandingHero,
    LandingHero2,
    LandingFeaturesCover,
    LandingFeaturesCoverItem,
    LandingFeaturesSlider,
    LandingFeaturesSimple,
    LandingFeaturesSimpleItem,
    LandingComoCards,
    LandingComoCardsItem,
    FeaturesCoverItemListUpdate,
  },
};
</script>

<style lang="scss" scoped></style>
